module.exports = __webpack_public_path__ + "static/img/6.54f5d0ee.png";